import {http} from './http_service';

export function getInvoice(id, userId) {
    return http().post('/invoices/get-invoice', {
        "invoice_number" : id,
        "user_id" : userId
     });
}